import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import Table from '../Table/Table'
import TableControls from 'components/Table/TableControls'
import DocumentIcon from '@tecuity/sos-icons/react/document'
import { Body } from '../Shell/Shell'
import { Spinner } from '../Loaders/Loaders'
import { PageError } from '../PageError/PageError'
import {
  pullAndSetMyRecords,
  selectMyRecordsRow,
  selectMyRecordsRowAndGetDetails,
  setActiveCategory,
  setFilters,
  setMyRecordsResultsMode,
  initMyRecordsFilters,
} from './MyRecordsActions'
import { getOrderedResultsByCategory } from 'utilities'
import RecordDrawer from 'components/RecordDrawer/RecordDrawer'
import EmptyBox from './EmptyBox'
import './MyRecords.scss'
import * as api from '../../requests'
import { setMiscRecordsSelectedModule } from '../../actions'

const MY_RECORDS_DISABLE_EMPTY_STATE = process.env.MY_RECORDS_DISABLE_EMPTY_STATE
const MY_RECORDS_EMPTY_STATE_LINE_1 = process.env.MY_RECORDS_EMPTY_STATE_LINE_1
const MY_RECORDS_EMPTY_STATE_LINE_2 = process.env.MY_RECORDS_EMPTY_STATE_LINE_2
const MY_RECORDS_SEARCH_PLACEHOLDER = process.env.MY_RECORDS_SEARCH_PLACEHOLDER

class MyRecords extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ownershipModalOpen: false,
      amendmentLauncherOpen: false,
      reinstatementModelOpen: false,
      module: '',
      filters: {},
    }
  }
  componentDidMount = () => {
    this.setState((state) => (state = { ...state, module: window.location.href.split('/').pop() }))
    api.GET_MY_RECORD_SEARCH_FILTERS((filters) => {
      const keys = Object.keys(filters)
      keys.forEach((key) => {
        Array.isArray(filters[key]) &&
          filters[key].forEach((filter) => {
            if (filter.type === 'select' && filter.apiCall) {
              api.GET_MY_RECORD_FILTER_OPTIONS(filter.apiCall, (results) => {
                if (filter.includeAllOption) {
                  results.push({ value: 0, label: 'All' })
                }

                results.sort((a, b) => a.value - b.value)
                filter.options = [...results]
                filters[key].find((x) => filter.name === x.name).options = results
                this.setState((state) => (state = { ...state, filters: filters }))
              })
            } else if (filter.type === 'dateRange') {
              filter.defaultValue = { start: '', end: '' }
              this.setState((state) => (state = { ...state, filters: filters }))
            }
          })
      })
    })

    const initSubParam = this.props.match.params.subParam
    const initSublink = (this.props.sublinks || []).find((l) => l.parameter === initSubParam) || {}
    if (initSubParam) {
      if (
        initSublink &&
        (initSublink.DisplayInMyRecord === true ||
          (initSublink.IsMiscRecordsType &&
            (initSublink.MiscRecordsModules || []).filter((m) => m.DisplayInMyRecords).length > 0))
      ) {
        if (initSublink.IsMiscRecordsType) {
          const initModules = (initSublink.MiscRecordsModules || []).filter(
            (m) => m.DisplayInMyRecords,
          )
          const initSelectedModuleId = this.props.miscRecordsSelectedModules[initSubParam]
          if (!initSelectedModuleId && initModules.length > 0) {
            this.props.setMiscRecordsSelectedModule(
              initSubParam,
              initModules[0].MiscellaneousModuleId,
            )
          }
        }
        this.props.setActiveCategory(initSubParam)
        this.getRecords()
      } else {
        this.props.history.replace(
          `/records/${
            this.props.sublinks.find(
              (x) =>
                x.DisplayInMyRecord === true ||
                (x.MiscRecordsModules || []).filter((m) => m.DisplayInMyRecords).length > 0,
            ).parameter
          }`,
        )
      }
    }
    this.props.initMyRecordsFilters()
  }
  componentDidUpdate = (prevProps) => {
    const module = window.location.href.split('/').pop()
    if (module !== this.state.module)
      this.setState((state) => (state = { ...state, module: module }))
    const updSubParam = this.props.match.params.subParam
    const updSublink = (this.props.sublinks || []).find((l) => l.parameter === updSubParam) || {}
    if (updSubParam !== prevProps.match.params.subParam) {
      if (
        updSublink &&
        (updSublink.DisplayInMyRecord === true ||
          (updSublink.MiscRecordsModules || []).filter((m) => m.DisplayInMyRecords).length > 0)
      ) {
        if (updSublink.IsMiscRecordsType) {
          const updModules = (updSublink.MiscRecordsModules || []).filter(
            (m) => m.DisplayInMyRecords,
          )
          const updSelectedModuleId = this.props.miscRecordsSelectedModules[updSubParam]
          if (!updSelectedModuleId && updModules.length > 0) {
            this.props.setMiscRecordsSelectedModule(
              updSubParam,
              updModules[0].MiscellaneousModuleId,
            )
          }
        }
        this.props.setActiveCategory(updSubParam)
        this.getRecords(updSubParam)
      } else {
        this.props.history.replace(
          `/records/${
            this.props.sublinks.find(
              (x) =>
                x.DisplayInMyRecord === true ||
                (x.MiscRecordsModules || []).filter((m) => m.DisplayInMyRecords).length > 0,
            ).parameter
          }`,
        )
      }
    }
  }
  getRecords = (nextCategory) => {
    this.props.pullAndSetMyRecords(
      nextCategory || this.props.match.params.subParam || this.props.sublinks[0].parameter,
    )
  }
  onBodyResize = ({ width, height }) => {
    if (width < 500 && this.props.resultsMode === 'table') {
      this.props.setMyRecordsResultsMode('cards')
    } else if (width >= 500 && this.props.resultsMode === 'cards') {
      this.props.setMyRecordsResultsMode('table')
    }
  }
  selectRow = (row) => {
    this.props.selectMyRecordsRowAndGetDetails(
      this.props.match.params.subParam,
      this.props.selectedId === row.ID ? null : row.ID,
    )
  }
  formatForCards = (template, rows) => {
    let cards = rows.map((row, i) => ({
      title: row[template[0].id],
      alert: row.ALERT_YN,
      details: this.formatRowDetails(template.slice(1), row),
      recordId: row.RECORD_ID,
      data: row,
    }))
    return cards
  }
  clearSelection = () => {
    this.props.selectMyRecordsRow(this.props.match.params.subParam, null)
  }
  closeOwnershipModalAndRefreshRecords = () => {
    this.ownershipModal.closeModal()
    this.getRecords()
  }
  setFilters = (filters, props = {}) => {
    this.props.setFilters(this.props.match.params.subParam, filters)
    if (props.getRecords !== false) {
      this.getRecords()
    }
  }

  getLowercaseSublinkLabel = (sublink) =>
    sublink.preserveCasing ? sublink.label || '' : (sublink.label || '').toLowerCase()

  getMergedEmptyStateText = (text, sublink) =>
    text.replace(/{{CATEGORY}}/g, this.getLowercaseSublinkLabel(sublink))

  renderEmptyResults(props, sublink) {
    const renderEmpty =
      !MY_RECORDS_DISABLE_EMPTY_STATE &&
      !props.loading &&
      props.orderedRecords &&
      !props.orderedRecords.rows.length

    if (renderEmpty) {
      let line1 = `Looks like you don't have any ${this.getLowercaseSublinkLabel(
        sublink,
      )} records yet`
      let line2 = `Visit ${this.getLowercaseSublinkLabel(
        sublink,
      )} forms to create your first record`
      if (MY_RECORDS_EMPTY_STATE_LINE_1) {
        line1 = this.getMergedEmptyStateText(MY_RECORDS_EMPTY_STATE_LINE_1, sublink)
      }
      if (MY_RECORDS_EMPTY_STATE_LINE_2) {
        line2 = this.getMergedEmptyStateText(MY_RECORDS_EMPTY_STATE_LINE_2, sublink)
      }
      return (
        <div className="empty-placeholder-wrapper">
          <EmptyBox />
          <h2>{line1}</h2>
          <p>{line2}</p>
          <div className="flex-row center">
            <Link className="btn btn-primary btn-raised" to={`/forms/${sublink.parameter}`}>
              Go to {this.getLowercaseSublinkLabel(sublink)} forms
            </Link>
            <p className="or">or</p>
            <Link className="btn btn-neutral" to={`/search/${sublink.parameter}`}>
              Search {this.getLowercaseSublinkLabel(sublink)} records
            </Link>
          </div>
        </div>
      )
    } else {
      return null
    }
  }

  renderPageData(props) {
    if (props.error) {
      return <PageError errorDetails={props.errorDetails} />
    } else if (!props.orderedRecords) {
      return <Spinner className="page-loader" />
    } else {
      const actionMap = {
        default: [
          {
            iconClass: '',
            label: 'View Filing',
            className: 'primary',
            onClick: this.selectRow,
            children: <DocumentIcon />,
          },
        ],
      }
      return (
        <Table
          label="My Records"
          template={props.orderedRecords.template}
          rows={props.orderedRecords.rows}
          className="center-container"
          actionMap={actionMap}
          actionCell={true}
          onCellClick={this.selectRow}
          selectedRowIndex={
            props.orderedRecords.rows
              ? props.orderedRecords.rows.findIndex((row) => row.ID === props.selectedId)
              : false
          }
          animated={false}
          rowCount
        />
      )
    }
  }

  render() {
    const {
      // resultsMode = 'table',
      loading,
      records,
      selectedId,
      showSelected,
      activeCategory,
      sublinks,
      filters,
      defaultCategory,
    } = this.props
    const category = this.props.match.params.subParam
    const selectedRecord = records[selectedId]
    const selectedTitle = selectedRecord ? selectedRecord.TITLE[0] : ''
    const selectedSubtitle = selectedRecord ? selectedRecord.TITLE[1] : ''
    const sublink = sublinks.find((l) => l.parameter === category) || {}
    const activeFilters = filters[category] || {}

    return (
      <Body
        className="my-records"
        showDrawer={selectedRecord && showSelected}
        onResize={this.onBodyResize}
        hiddenTitle="My Records"
      >
        {!this.props.match.params.subParam && (
          <Redirect
            to={`${this.props.location.pathname}/${
              activeCategory
                ? activeCategory
                : defaultCategory
                  ? defaultCategory
                  : this.props.sublinks[0].parameter
            }`}
          />
        )}
        <TableControls
          title={`My ${sublink.label} Records`}
          module={this.props.sublinks[0].parameter}
          description={sublink.myRecordsDescription}
          filterTemplates={this.state.filters[this.state.module]}
          filters={activeFilters}
          onFilterChange={this.setFilters}
          allowSearch={sublink.myRecordsSearch !== false}
          loading={loading}
          searchPlaceholder={MY_RECORDS_SEARCH_PLACEHOLDER || 'Search My Records'}
          sublink={sublink}
          miscRecordsModules={(sublink.MiscRecordsModules || []).filter((m) => m.DisplayInMyRecords)}
        />

        {this.renderPageData(this.props)}

        {this.renderEmptyResults(this.props, sublink)}

        <RecordDrawer
          show={selectedRecord && selectedId ? true : false}
          title={selectedTitle}
          subtitle={selectedSubtitle}
          category={category}
          sourceId={selectedRecord && selectedRecord.ID}
          uccRecordId={selectedRecord && selectedRecord.UCC_RECORD_ID}
          recordNum={selectedRecord && selectedRecord.RECORD_NUM}
          canFileAR={selectedRecord && selectedRecord.CAN_FILE_AR}
          canReinstate={selectedRecord && selectedRecord.CAN_REINSTATE}
          canFileReinstatement={selectedRecord && selectedRecord.CAN_FILE_REINSTATEMENT}
          showCopyRequests={selectedRecord && selectedRecord.SHOW_COPY_REQUESTS}
          userOwnsCurrentRecord={process.env.USER_ACCESS_LEVEL_MANAGEMENT ? false : true}
          canAlwaysFileAR={selectedRecord && selectedRecord.CAN_ALWAYS_FILE_AR}
          onRequestRecordsRefresh={this.getRecords}
          sublink={sublink}
          onSidebarDismiss={this.clearSelection}
        />
      </Body>
    )
  }
}
MyRecords = connect(
  (state, props) => ({
    orderedRecords:
      props.match.params.subParam && state.myRecords.results
        ? getOrderedResultsByCategory(
            props.match.params.subParam,
            state.myRecords.results,
            state.myRecords.templates,
          )
        : null,
    records:
      props.match.params.subParam && state.myRecords.results
        ? state.myRecords.results[props.match.params.subParam]
          ? state.myRecords.results[props.match.params.subParam]
          : {}
        : {},
    resultsMode: state.myRecords.resultsMode,
    loading: state.myRecords.loading,
    selectedId: props.match.params.subParam
      ? state.myRecords.selected[props.match.params.subParam]
      : null,
    showSelected: state.myRecords.showSelected,
    selectedDetails: state.myRecords.selectedDetails,
    isMobile: state.app.isMobile,
    recordDetailsLoading: state.myRecords.recordDetailsLoading,
    activeCategory: state.myRecords.activeCategory || state.app.currentCategory,
    filters: state.myRecords.filters,
    error: state.myRecords.error,
    errorDetails: state.myRecords.errorDetails,
    defaultCategory: state.app.appSettings['RecordsDefaultCategory'],
    miscRecordsSelectedModules: state.app.miscRecordsSelectedModules,
  }),
  {
    pullAndSetMyRecords,
    setMyRecordsResultsMode,
    selectMyRecordsRowAndGetDetails,
    selectMyRecordsRow,
    setActiveCategory,
    setFilters,
    initMyRecordsFilters,
    setMiscRecordsSelectedModule,
  },
)(MyRecords)

export default MyRecords
